<tm-menubar-button [component]="componentType"
                   [panelTitle]="panelLabel$ | async"
                   [tooltip]="panelLabel$ | async"
                   icon="components_table_of_contents"></tm-menubar-button>
